import { Divider, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ReactComponent as MediaIcon } from 'assets/icons/edit-image.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit-white.svg';
import { DrawerMedia, GridWrap, InfoWrapper, Table } from 'components';
import { FieldType, MediaGroup, UploadMedia } from 'constants/inspections';
import {
  geometriaSezioneTiranteOptions,
  tipologiaTiranteOptions,
} from 'constants/selectOptions';
import { useInspectionPath } from 'hooks';
import { INFO } from 'pages/Inspections/config/info';
import { useInspectionSelector } from 'stores';
import TirantiForm from './TirantiForm';

const TirantiSection = ({ selectedIdx }) => {
  const { watch, setValue, getValues } = useFormContext();
  const { inspectionDisabled } = useInspectionSelector();
  const { isViewingInspection } = useInspectionPath();

  const mensoleTamponiCampateImpalcatoTableTirantiTableWatch = watch(
    `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].tirantiTable`
  );

  // table setup
  const dataConfigTiranti = {
    columns: {
      codice: { label: 'Codice' },
      tipologiaTirante: {
        label: 'Tipologia',
        format: tipologiaTiranteOptions,
      },
      geometriaSezioneTirante: {
        label: 'Geometria sezione',
        format: geometriaSezioneTiranteOptions,
      },
      lunghezzaTirante: {
        label: 'L [cm]',
      },
      diametroTirante: {
        label: 'D [cm]',
      },
      spessoreTirante: {
        label: 's [cm]',
      },
      profonditaTirante: {
        label: 'P [cm]',
      },
    },
  };

  // tiranti setup
  const [selectedTiranti, setSelectedTiranti] = useState([]);
  const [open, setOpen] = useState(false);
  const [drawerMediaIndex, setDrawerMediaIndex] = useState();

  const editRowsTiranti = item => {
    setValue('l0t2a5_tirantiTableValue', [item]);
    setValue('l0t2a5_tipologiaTiranteTableValue', item.tipologiaTirante);
    setValue(
      'l0t2a5_geometriaSezioneTiranteTableValue',
      item.geometriaSezioneTirante
    );
    setValue('l0t2a5_lunghezzaTiranteTableValue', item.lunghezzaTirante);
    setValue('l0t2a5_diametroTiranteTableValue', item.diametroTirante);
    setValue('l0t2a5_spessoreTiranteTableValue', item.spessoreTirante);
    setValue('l0t2a5_profonditaTiranteTableValue', item.profonditaTirante);
  };
  const handleSelectAllClickTiranti = event => {
    if (event.target.checked) {
      const selectedValue = getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].tirantiTable`
      );
      setSelectedTiranti(selectedValue);
      setValue('l0t2a5_tirantiTableValue', selectedValue);
    } else {
      setSelectedTiranti([]);
      setValue('l0t2a5_tirantiTableValue', []);
    }
  };

  return (
    <>
      <GridWrap container spacing={2} style={{ marginTop: 16 }}>
        <InfoWrapper
          isDivider={true}
          size={12}
          infoDrawer={true}
          drawerTitle={INFO.impalcatoTiranti.drawerTitle}
          drawerText={INFO.impalcatoTiranti.drawerText}
        >
          <Divider>TIRANTI</Divider>
        </InfoWrapper>
        {mensoleTamponiCampateImpalcatoTableTirantiTableWatch?.length === 0 && (
          <GridWrap item xs={12} paddingTop={'0px !important'}>
            <Typography>Nessun tirante presente in questo elemento</Typography>
          </GridWrap>
        )}
      </GridWrap>
      {mensoleTamponiCampateImpalcatoTableTirantiTableWatch?.length > 0 && (
        <>
          {!inspectionDisabled && !isViewingInspection && (
            <TirantiForm
              tirantiFields={
                mensoleTamponiCampateImpalcatoTableTirantiTableWatch || []
              }
              selected={selectedTiranti}
              setSelected={setSelectedTiranti}
              tirantiTable={`mensoleTamponiCampateImpalcatoTable[${selectedIdx}].tirantiTable`}
              selectedIdx={selectedIdx}
            />
          )}
          <DrawerMedia
            open={open}
            setOpen={setOpen}
            title={'Tiranti'}
            infoPanel="Per un'ottimizzazione nel report, si consiglia di eseguire foto in orizzontale in rapporto 4:3."
            dataType="video/*,image/*"
            uploadType={UploadMedia.media}
            type={FieldType.images}
            formName={`mensoleTamponiCampateImpalcatoTable[${selectedIdx}].tirantiTable[${drawerMediaIndex}].media`}
            mediaGroup={[MediaGroup.Struttura]}
          />
          <GridWrap container spacing={2} mt={2}>
            <GridWrap item xs={12}>
              <Table
                data={
                  mensoleTamponiCampateImpalcatoTableTirantiTableWatch || []
                }
                config={dataConfigTiranti}
                hasCheckbox={!inspectionDisabled && !isViewingInspection}
                rowActions={
                  !inspectionDisabled && !isViewingInspection
                    ? [
                        {
                          onClick: item => {
                            editRowsTiranti(item);
                            setSelectedTiranti([item]);
                          },
                          icon: <EditIcon />,
                        },
                      ]
                    : []
                }
                mediaActions={[
                  {
                    onClick: item => {
                      setDrawerMediaIndex(
                        mensoleTamponiCampateImpalcatoTableTirantiTableWatch.findIndex(
                          el => el.id === item.id
                        )
                      );
                      setOpen(true);
                    },
                    icon: <MediaIcon />,
                  },
                ]}
                selected={selectedTiranti}
                onSelectAllClick={handleSelectAllClickTiranti}
                setSelected={setSelectedTiranti}
              />
            </GridWrap>
          </GridWrap>
        </>
      )}
    </>
  );
};
TirantiSection.propTypes = {
  selectedIdx: PropTypes.number,
};
export default TirantiSection;
